export const BUlist = [
  { id: 1, name: "BU1" },
  { id: 2, name: "BU2" },
  { id: 3, name: "BU3" }
];

export const SuppliersList = [
  { id: 1, supplier_name: "SupplierB" },
  { id: 2, supplier_name: "SupplierC" },
  { id: 3, supplier_name: "SupplierE" },
  { id: 4, supplier_name: "SupplierA" }
];
